var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"review-container",staticClass:"review-container",class:{one: _vm.notes.length === 1}},_vm._l((_vm.notes),function(note){return _c('div',{key:note.id,staticClass:"card"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.markdown(_vm.showContent(note)))}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }